import { protectedApi } from './requester'

export const getMaterials = async () => {
  return protectedApi.get<string[]>('/materials').then((response) => response.data)
}
